export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetDemoBook(context) {
      context.commit("updateDemoBook", false)
    },
  },
  mutations: {
    updateDemoBook(state, data) {
      return state.data = data
    }
  }
}